"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _popupConfig = require("@/api/popup/popupConfig.js");
var _memberManagement = require("@/api/member/memberManagement");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: '优惠券详情',
  props: {
    couponData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    // 树节点勾选 key：门店节点的 nodeKey 为 's' + storeId，与 checkedShopIds 中的原始 storeId 做映射
    checkedKeys: function checkedKeys() {
      return this.checkedShopIds.map(function (id) {
        return 's' + id;
      });
    },
    // 解析公众号信息
    parsedMpIds: function parsedMpIds() {
      if (!this.couponData.mpIds) {
        return [];
      }
      try {
        return JSON.parse(this.couponData.mpIds);
      } catch (e) {
        console.error('解析公众号信息失败:', e);
        return [];
      }
    }
  },
  data: function data() {
    return {
      // 门店相关数据
      shopTreeData: [],
      shopTreeProps: {
        children: 'children',
        label: 'treeLabel' // 使用我们自定义的标签字段
      },
      expandedKeys: [],
      checkedShopIds: [],
      imagePrefix: '' // 添加图片前缀字段
    };
  },
  watch: {
    couponData: {
      handler: function handler(newVal) {
        if (newVal && newVal.shopIds !== undefined) {
          this.initShopData(newVal.shopIds);
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    this.getImagePrefix(); // 获取图片前缀
    this.getShopList();
  },
  methods: {
    // 获取图片前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取图片前缀失败:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 获取完整图片URL
    getImageUrl: function getImageUrl(url) {
      // 如果没有url则返回空
      if (!url) return '';

      // 如果已经是完整URL则直接返回
      if (url.startsWith('http')) {
        return url;
      }

      // 如果有图片前缀，使用图片前缀
      if (this.imagePrefix) {
        // 确保前缀末尾没有斜杠，url开头有斜杠
        var prefix = this.imagePrefix.endsWith('/') ? this.imagePrefix.slice(0, -1) : this.imagePrefix;
        var path = url.startsWith('/') ? url : '/' + url;
        return prefix + path;
      }

      // 如果是相对路径，则加上基础URL
      return process.env.VUE_APP_BASE_API + url;
    },
    // 获取优惠券类型文本
    getCouponTypeText: function getCouponTypeText(type) {
      var typeMap = {
        1: '满减券',
        2: '折扣券',
        3: '品项券',
        4: '赠品券',
        5: '免邮券'
      };
      return typeMap[type] || '未知类型';
    },
    // 格式化金额显示
    formatAmount: function formatAmount(amount) {
      return typeof amount === 'number' ? amount.toFixed(2) : amount;
    },
    // 格式化时间显示
    formatDateTime: function formatDateTime(time) {
      if (!time) return '无';
      // 假设time是时间戳格式
      var date = new Date(time);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      var seconds = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    },
    // 返回上一页
    goBack: function goBack() {
      this.$emit('go-back');
    },
    // 获取门店列表
    getShopList: function () {
      var _getShopList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, seenRegionIds, seenStoreIds, _processData, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _popupConfig.getShops)();
            case 1:
              response = _context2.sent;
              if (response.code === 200 && response.data) {
                // 后端数据里区域id可能与门店storeId撞号、同一门店可能出现在多个区域下，
                // 直接用 id 作为 node-key 会因 key 重复导致 setCheckedKeys 勾选不上部分门店，
                // 因此用 nodeKey 保证唯一（区域 'r'+id、门店 's'+storeId），并对重复区域/门店去重
                seenRegionIds = new Set();
                seenStoreIds = new Set(); // 处理数据，确保每个节点都有正确的nodeKey和标签字段
                _processData = function processData(nodes) {
                  var resultList = [];
                  nodes.forEach(function (node) {
                    // 创建一个新的节点对象
                    var processedNode = _objectSpread({}, node);
                    if (node.storeId === undefined) {
                      // 对于地区节点，同一区域只保留第一次出现
                      if (seenRegionIds.has(node.id)) return;
                      seenRegionIds.add(node.id);
                      processedNode.id = node.id;
                      processedNode.nodeKey = 'r' + node.id;
                      processedNode.isRegion = true;
                      processedNode.treeLabel = node.label;
                    } else {
                      // 对于门店节点，同一门店只保留第一次出现
                      if (seenStoreIds.has(node.storeId)) return;
                      seenStoreIds.add(node.storeId);
                      processedNode.id = node.storeId;
                      processedNode.nodeKey = 's' + node.storeId;
                      processedNode.treeLabel = node.shopName;
                    }

                    // 递归处理子节点
                    if (node.children && node.children.length > 0) {
                      processedNode.children = _processData(node.children);
                    }
                    resultList.push(processedNode);
                  });
                  return resultList;
                };
                this.shopTreeData = _processData(response.data);
                // 设置默认展开的节点为所有顶级节点
                this.expandedKeys = this.shopTreeData.map(function (item) {
                  return item.nodeKey;
                });
              } else {
                this.$message.error('获取门店列表失败');
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('获取门店列表错误：', _t2);
              this.$message.error('获取门店列表失败');
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getShopList() {
        return _getShopList.apply(this, arguments);
      }
      return getShopList;
    }(),
    // 初始化门店数据
    initShopData: function initShopData(shopIds) {
      var _this = this;
      // 根据shopIds设置选中的门店
      if (shopIds && shopIds !== '') {
        var ids = shopIds.split(',').map(function (id) {
          return parseInt(id);
        });
        this.checkedShopIds = ids;
      } else {
        // 如果shopIds为空或不存在，则选中所有门店
        this.checkedShopIds = this.getAllStoreIds(this.shopTreeData);
      }

      // 确保在DOM更新后设置选中状态（入参需用 's' + storeId 形式的 nodeKey）
      this.$nextTick(function () {
        if (_this.$refs.shopTree) {
          _this.$refs.shopTree.setCheckedKeys(_this.checkedKeys);
        }
      });
    },
    // 获取所有门店ID（返回原始 storeId，业务数据保持不变）
    getAllStoreIds: function getAllStoreIds(nodes) {
      var _this2 = this;
      var ids = [];
      nodes.forEach(function (node) {
        if (node.children && node.children.length > 0) {
          ids = ids.concat(_this2.getAllStoreIds(node.children));
        } else if (!node.isRegion && node.storeId !== undefined) {
          // 这是门店节点
          ids.push(node.storeId);
        }
      });
      return ids;
    }
  }
};